import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor() {
  }

  consentToCookies(): void {
    localStorage.setItem('consentToCookies', 'true');
  }

  getConsentToCookies(): boolean {
    const isConsent = localStorage.getItem('consentToCookies');
    if (isConsent) {
      return !!isConsent;
    }
  }

}
